<template>
<div>
   <div class="noticeData" v-html="agreementData.templateHtml"></div>
</div>

</template>

<script>
import planSaleApi from "@/request/planSaleApi";
export default {
  name: "ViewAgreement",
  props: {
    title: {
      type: String,
      default: "协议查看"
    }
  },
  data() {
    return {
      visiable: false,
      agreementData: {}
    };
  },
  methods: {
    viewAgreement(agreementType, templateId) {
      let params = {
        agreementType,
        templateId
      };
      planSaleApi.getAgreement(params).then(res=>{
        if (res.returnCode == "0") {
          this.agreementData = res.result.dataList[0];
          this.tilte= this.agreementData.agreementName;
          console.log("agreementData", this.agreementData);
          this.visiable = true;
        } else {
          this.$toast({
                type: "fail",
                message: res.returnMessage,
                duration: 1500,
          });
        }

      });
      
    }
  }
};
</script>

<style lang="stylus" scoped>
.noticeData {
  // max-height: 600px;
  overflow-y: scroll;
  min-width: 80%;
  padding: 40px;
  background:#fff;
}
</style>